import React from 'react';
import ReactJson from 'react-json-view';
import Modal from '@cp/components/Modal/Modal';
import { GenericObject } from '@cp/src/types/CommonConstans';

type CriteriaModalProps = {
  showModal: boolean;
  setShowModal: React.Dispatch<React.SetStateAction<boolean>>;
  modalContent: string;
};

function CriteriaModal({
  showModal,
  setShowModal,
  modalContent = '{"foo": "bar"}'
}: CriteriaModalProps) {
  return (
    <Modal
      iconButtonSize="small"
      headerClassName="bg-[#f1f9f9] rounded"
      contentClassName="w-[800px] h-[600px] overflow-auto mx-[20px] my-[20px]"
      visible={showModal}
      header={'Segment criteria'}
      onClose={() => setShowModal(false)}
    >
      <ReactJson src={modalContent ? JSON.parse(modalContent) : ''} name={'criteria'} />
    </Modal>
  );
}

export default CriteriaModal;
